module.exports = {"441481001":"兴田街道","441481002":"福兴街道","441481003":"宁新街道","441481107":"永和镇","441481111":"新圩镇","441481115":"罗浮镇","441481116":"罗岗镇","441481117":"黄槐镇","441481123":"龙田镇","441481124":"石马镇","441481128":"宁中镇","441481129":"径南镇","441481130":"坭陂镇","441481131":"水口镇","441481132":"黄陂镇","441481133":"合水镇","441481134":"大坪镇","441481135":"叶塘镇","441481136":"新陂镇","441481137":"刁坊镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441481.json
// module id = 2157
// module chunks = 0